angular.module('lsnBase.deprecated.models')
  .factory('ApplicationAllowedChangesObjectModel', ['LsnApplicationAllowedChangesObjectModelV1',
    function(LsnApplicationAllowedChangesObjectModelV1) {
      return LsnApplicationAllowedChangesObjectModelV1;
    }
  ]);